// The consignee's 4-digit delivery code (12 §12.5 step 6). The server stores only a hash; this
// file holds the parts that need no secret: what a code looks like and what a check means.

export const DELIVERY_CODE_PATTERN = /^\d{4}$/;

export function isDeliveryCode(value: string): boolean {
  return DELIVERY_CODE_PATTERN.test(value);
}

export type DeliveryCodeVerdict = {
  /** `true` when the code was right, `false` when it was wrong, `undefined` when none was given or issued. */
  readonly deliveryCodeOk: boolean | undefined;
  /** A delivery with no code, or the wrong one, is flagged for the office (12 §12.5). */
  readonly verified: boolean;
};

/**
 * `given` is what the partner typed; `matches` says whether it hashes to the stored hash, and is
 * only asked when a code was given and one was issued for the shipment.
 */
export function judgeDeliveryCode(
  given: string | undefined,
  issued: boolean,
  matches: (code: string) => boolean,
): DeliveryCodeVerdict {
  if (given === undefined || !isDeliveryCode(given) || !issued) {
    return { deliveryCodeOk: undefined, verified: false };
  }
  const ok = matches(given);
  return { deliveryCodeOk: ok, verified: ok };
}
